module.exports = __webpack_public_path__ + "assets/img/terrestrial.dfd45030.webp";